import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { FieldArray, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { ResumeWorkExpericeSchema } from "../../../validation/validator";
import Form from "react-bootstrap/Form";
import { RootState } from "../../../store/store";
import { setResumeDetails } from "../../../store/resume.store";
import { useCustomNavigate } from "../../../hooks/useCustomNavigate";
import { AppRoute } from "../../../router/routerConstants";
import moment from "moment";
import { TagsInput } from "react-tag-input-component";

interface Experience {
  from: Date | null;
  to: Date | null;
  role: string;
  company: string;
  responsibilities: string[];
}

interface WorkExperiences {
  experiences: Experience[];
}
const AddExpericeModal = ({
  show,
  isBulkEdit,
  isSingleEdit,
  onClose,
  getExperienceList,
  editDetails
}: any) => {
  const dispatch = useDispatch();

  const { resumeDetails } = useSelector(
    (state: RootState) => state.resumeSlice
  );
  // const selectedResume = editDetails? resumeList.find(resume => resume._id === editDetails._id) : null;
  const effectiveResumeDetails = editDetails || resumeDetails;

  const { user } = useSelector((state: RootState) => state.authSlice);
  const [NavigateTo] = useCustomNavigate();
  // console.log(resumeDetails,effectiveResumeDetails,88544);
  
  const defaultWorkExperiences = {
    experiences: [
      {
        from: null,
        to: null,
        role: "",
        company: "",
        responsibilities: [],
      },
    ],
  };

  const [workExperiences, setWorkExperiences] = useState<WorkExperiences>(
    defaultWorkExperiences
  );

  useEffect(() => {
    if (isSingleEdit && getExperienceList) {
      setWorkExperiences({ experiences: getExperienceList.experiences });
    } else if (effectiveResumeDetails?.experiences && isBulkEdit) {
      setWorkExperiences({ experiences: effectiveResumeDetails?.experiences });
    } else {
      setWorkExperiences(defaultWorkExperiences);
    }
    // console.log(getExperienceList,88888);
    // eslint-disable-next-line react-hooks/exhaustive-deps    
  }, [effectiveResumeDetails, getExperienceList, isBulkEdit, isSingleEdit]);

  const handleSubmit = (values: any) => {
    const updatedExperiences = values.experiences.map((exp: Experience) => ({
      ...exp,
      from: exp.from ? moment(exp.from).format("YYYY-MM-DD") : null,
      to: exp.to ? moment(exp.to).format("YYYY-MM-DD") : null,
    }));

    const totalExperienceInYears = values.experiences.reduce(
      (total: number, experience: Experience) => {
        if (!experience?.from || !experience.to) {
          return total; // Skip this entry if either date is null/undefined
        }

        const fromDate = new Date(experience.from);
        const toDate = new Date(experience.to);

        if (isNaN(fromDate.getTime()) || isNaN(toDate.getTime())) {
          return total; // Skip invalid dates
        }

        const differenceInMilliseconds = toDate.getTime() - fromDate.getTime();
        const differenceInYears =
          differenceInMilliseconds / (1000 * 60 * 60 * 24 * 365.25); // Approximate year length

        return total + differenceInYears;
      },
      0
    );

    const formattedExperience = `${totalExperienceInYears.toFixed(1)} years`;

    if (isBulkEdit) {
      const updatedDetails = {
        ...effectiveResumeDetails,
        explevel: formattedExperience,
        experiences: updatedExperiences,
      };

      dispatch(setResumeDetails(updatedDetails));
    }

    if (isSingleEdit && Array.isArray(getExperienceList?.experiences)) {
      if (
        effectiveResumeDetails?.experiences &&
        Array.isArray(effectiveResumeDetails.experiences)
      ) {
        const targetExperience = getExperienceList?.experiences[0];
        const updatedExperienceIndex = effectiveResumeDetails?.experiences?.findIndex(
          (exp: Experience) =>
            Object.keys(targetExperience).every(
              (key) =>
                exp[key as keyof Experience] ===
                targetExperience[key as keyof Experience]
            )
        );

        if (updatedExperienceIndex !== -1) {
          const updatedDetails = {
            ...effectiveResumeDetails,
            explevel: formattedExperience,
            experiences:
              effectiveResumeDetails?.experiences &&
              effectiveResumeDetails?.experiences?.map(
                (exp: Experience, index: number) =>
                  index === updatedExperienceIndex
                    ? { ...exp, ...updatedExperiences[0] }
                    : exp
              ),
          };

          dispatch(setResumeDetails(updatedDetails));
        }
      }
    }

    if (!isBulkEdit && !isSingleEdit) {
      const updatedDetails = {
        ...effectiveResumeDetails,
        explevel: formattedExperience,
        // experiences: updatedExperiences, // updated on 13june25 by pratick
        experiences: [...(effectiveResumeDetails?.experiences || []), ...updatedExperiences]
      };

      dispatch(setResumeDetails(updatedDetails));
      onClose();
      if (user && user?.role === "jobseeker") {
        NavigateTo(AppRoute.JOBSEEKER_ADDED_WORK_EXPERIENCE);
      } else if (user && user?.role === "localagents") {
        NavigateTo(AppRoute.AGENT_ADDED_WORK_EXPERIENCE);
      }
    }

    onClose();
  };

  const getFieldError = (
    errors: any,
    field: string,
    index: number
  ): string | undefined => {
    if (
      errors.experiences?.[index] &&
      typeof errors.experiences[index] === "object"
    ) {
      return errors.experiences[index][field];
    }
    return undefined;
  };

  return (
    <Modal
      show={show}
      onHide={onClose} // Closes modal on cross or outside click
      // backdrop="static" // Prevent close on clicking outside
      keyboard={false} // Prevent close with the keyboard (Esc)
      animation={false}
      aria-labelledby="contained-modal-title-vcenter"
      className="editPersonalInformation"
      centered
    >
      <button
        type="button"
        className="btn-close custom-close-btn"
        onClick={onClose}
        aria-label="Close"
        style={{
          position: "absolute",
          top: "20px",
          right: "20px",
          zIndex: 9,

          border: "none",
          fontSize: "1rem",
          cursor: "pointer",
        }}
      ></button>
      <Modal.Body>
        <div className="findbody">
          <h3>
            {isBulkEdit || isSingleEdit ? "Edit Experience" : "Add Experience"}
          </h3>
          <Formik
            initialValues={workExperiences}
            enableReinitialize={true}
            validationSchema={ResumeWorkExpericeSchema}
            onSubmit={handleSubmit}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              setFieldValue,
              setFieldError,
            }) => (
              <Form className="modalSearch" onSubmit={handleSubmit}>
                <FieldArray
                  name="experiences"
                  render={(arrayHelpers) => (
                    <div>
                      {values?.experiences &&
                        values.experiences?.map(
                          (experience: Experience, index: number) => (
                            <div key={index} className="work-experience-form">
                              <Form.Group className="mb-3">
                                <Form.Label>From</Form.Label>
                                <Form.Control
                                  type="date"
                                  name={`experiences.${index}.from`}
                                  value={
                                    experience.from
                                      ? moment(experience.from).format(
                                          "YYYY-MM-DD"
                                        )
                                      : ""
                                  }
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  placeholder="Starting date"
                                  max={moment().format("YYYY-MM-DD")}
                                />
                                {getFieldError(errors, "from", index) &&
                                  touched.experiences?.[index]?.from && (
                                    <div className="text-danger">
                                      {getFieldError(errors, "from", index)}
                                    </div>
                                  )}
                              </Form.Group>
                              <Form.Group className="mb-3">
                                <Form.Label>To</Form.Label>
                                <Form.Control
                                  type="date"
                                  name={`experiences.${index}.to`}
                                  value={
                                    experience.to
                                      ? moment(experience.to).format(
                                          "YYYY-MM-DD"
                                        )
                                      : ""
                                  }
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  placeholder="Ending date"
                                  max={moment().format("YYYY-MM-DD")}
                                />
                                {getFieldError(errors, "to", index) &&
                                  touched.experiences?.[index]?.to && (
                                    <div className="text-danger">
                                      {getFieldError(errors, "to", index)}
                                    </div>
                                  )}
                              </Form.Group>

                              <Form.Group className="mb-3">
                                <Form.Label>Job Role</Form.Label>
                                <Form.Control
                                  type="text"
                                  name={`experiences.${index}.role`}
                                  value={experience.role}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  placeholder="Enter your  Role"
                                />
                                {getFieldError(errors, "role", index) &&
                                  touched.experiences?.[index]?.role && (
                                    <div className="text-danger">
                                      {getFieldError(errors, "role", index)}
                                    </div>
                                  )}
                              </Form.Group>
                              <Form.Group className="mb-3">
                                <Form.Label>Company Name</Form.Label>
                                <Form.Control
                                  type="text"
                                  name={`experiences.${index}.company`}
                                  value={experience.company}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  placeholder="Enter your Company name"
                                />
                                {getFieldError(errors, "company", index) &&
                                  touched.experiences?.[index]?.company && (
                                    <div className="text-danger">
                                      {getFieldError(errors, "company", index)}
                                    </div>
                                  )}
                              </Form.Group>
                              <Form.Group className="mb-3">
                                <Form.Label>
                                  Responsibility{" "}
                                  <span className="text-danger">
                                    ( Press Enter after entering a value. )
                                  </span>
                                </Form.Label>
                                <TagsInput
                                  value={experience.responsibilities}
                                  onChange={(newTags) =>
                                    setFieldValue(
                                      `experiences.${index}.responsibilities`,
                                      newTags
                                    )
                                  }
                                  onBlur={handleBlur}
                                  name={`experiences.${index}.responsibilities`}
                                  placeHolder="Enter your Responsibility"
                                />

                                {getFieldError(
                                  errors,
                                  "responsibilities",
                                  index
                                ) &&
                                  touched.experiences?.[index]
                                    ?.responsibilities && (
                                    <div className="text-danger">
                                      {getFieldError(
                                        errors,
                                        "responsibilities",
                                        index
                                      )}
                                    </div>
                                  )}
                              </Form.Group>
                              {values.experiences.length > 1 && (
                                <Button
                                  variant="danger"
                                  className="mb-3"
                                  onClick={() => arrayHelpers.remove(index)}
                                >
                                  Remove
                                </Button>
                              )}
                            </div>
                          )
                        )}
                      <div className="d-flex gp-10">
                        {!isSingleEdit && (
                          <Button
                            className="btn btn-black w-100"
                            onClick={() =>
                              arrayHelpers.push({
                                from: null,
                                to: null,
                                role: "",
                                company: "",
                                responsibilities: [],
                              })
                            }
                          >
                            Add More
                          </Button>
                        )}
                        <Button className="btn w-100" type="submit">
                          {isBulkEdit || isSingleEdit ? "Update" : "Save"}
                        </Button>
                      </div>
                    </div>
                  )}
                />
              </Form>
            )}
          </Formik>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AddExpericeModal;
